// components/contribute/Leaderboard.js
import { useState, useEffect } from 'react'
import gamificationService from '../../services/gamificationService'
import { useAuth } from '../../contexts/AuthContext'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech'
import StarIcon from '@mui/icons-material/Star'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import './Leaderboard.css'

function Leaderboard ({ currentUserEmail }) {
  const { user } = useAuth()
  const [leaderboard, setLeaderboard] = useState([])
  const [userRanking, setUserRanking] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // NEU: Nur laden, wenn eine E-Mail und User vorhanden ist
    if (currentUserEmail && user) {
      loadLeaderboard()
    } else {
      // Optional: Ladezustand beenden, wenn keine E-Mail kommt
      setLoading(false)
    }
  }, [currentUserEmail, user])

  const loadLeaderboard = async () => {
    try {
      const [topUsers, ranking] = await Promise.all([
        gamificationService.getLeaderboard(user.uid, 10),
        gamificationService.getUserRanking(currentUserEmail, user.uid)
      ])

      setLeaderboard(topUsers)
      setUserRanking(ranking)
      setLoading(false)
    } catch (error) {
      console.error('Error loading leaderboard:', error)
      setLoading(false)
    }
  }

  const getRankIcon = position => {
    if (position === 1) return <WorkspacePremiumIcon className='medal-icon gold' />
    if (position === 2) return <WorkspacePremiumIcon className='medal-icon silver' />
    if (position === 3) return <WorkspacePremiumIcon className='medal-icon bronze' />
    return <span className='rank-number'>#{position}</span>
  }

  const getLevelColor = level => {
    if (level >= 5) return '#f44336'
    if (level >= 4) return '#9c27b0'
    if (level >= 3) return '#ff9800'
    if (level >= 2) return '#2196f3'
    return '#4caf50'
  }

  if (loading) {
    return (
      <div className='leaderboard'>
        <div className='leaderboard-header'>
          <EmojiEventsIcon className='header-icon' />
          <h3>Top Mitwirkende</h3>
        </div>
        <div className='leaderboard-loading'>Lädt...</div>
      </div>
    )
  }

  return (
    <div className='leaderboard'>
      <div className='leaderboard-header'>
        <div className='header-title'>
          <EmojiEventsIcon className='header-icon' />
          <h3>Top Mitwirkende</h3>
        </div>
        {userRanking && (
          <div className='user-ranking'>
            <TrendingUpIcon className='ranking-icon' />
            <span>Ihre Position: <strong>#{userRanking}</strong></span>
          </div>
        )}
      </div>

      <div className='leaderboard-list'>
        {leaderboard.map((user, index) => (
          <div
            key={user.email}
            className={`leaderboard-item ${
              user.email === currentUserEmail ? 'current-user' : ''
            } ${index < 3 ? 'top-three' : ''}`}
          >
            <div className='rank-position'>{getRankIcon(index + 1)}</div>

            <div className='user-info'>
              <div className='user-name'>
                {user.email === currentUserEmail ? (
                  <span>
                    <strong>Sie</strong> ({user.email})
                  </span>
                ) : (
                  user.email.split('@')[0]
                )}
              </div>
              <div
                className='user-rank'
                style={{ color: getLevelColor(user.level) }}
              >
                <StarIcon className='rank-star' />
                {user.rank}
              </div>
            </div>

            <div className='user-stats-leaderboard'>
              <div className='stat-item'>
                <span className='stat-value'>{user.totalContributions}</span>
                <span className='stat-label'>Beiträge</span>
              </div>
              <div className='stat-item'>
                <span className='stat-value'>{user.points}</span>
                <span className='stat-label'>Punkte</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {!leaderboard.find(u => u.email === currentUserEmail) &&
        userRanking > 10 && (
          <div className='leaderboard-footer'>
            <MilitaryTechIcon className='footer-icon' />
            <p>
              Sie sind auf Platz {userRanking}! Noch {userRanking - 10}{' '}
              {userRanking - 10 === 1 ? 'Platz' : 'Plätze'} bis zu den Top 10!
            </p>
          </div>
        )}
    </div>
  )
}

export default Leaderboard
